/*
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React, { Component } from 'react';
import {
  Grid,
  Select,
  Loader,
  Modal,
  Input,
  Button,
  Icon,
  Tooltip,
  InputLabel,
} from '@scuf/common';
import { DataTable } from '@scuf/datatable';
import { NotificationHeaderModal } from '@keystone/common';
import { withRouter } from 'react-router-dom';
import {
  withOperatorContext,
  withCustomerSiteContext,
  withApplicationContext,
} from '../../common/HOCs';
import AppModal from '../../partials/AppModal';
import Routes from '../../common/routes';
import SiteTable from '../../partials/SiteTable';

class ViewOperators extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        operatorId: null,
        firstName: null,
        lastName: null,
        email: null,
        sites: null,
      },
      operators: null,
      loadingSettings: false,
      open: false,
      openEdit: false,
      openOpSettings: false,
      disableMultipleDelete: true,
      hasDimmer: true,
      allSites: null,
      platformOptions: [],
      selectedPlatformValue: 0,
      allProperties: [],
    };
  }

  componentDidMount() {
    const { appContext } = this.props;
    appContext.registerReloadFunction(this.reloadTableComponent);
    this.initializeTable();
    this.props.appContext.setNotification(null);
  }

  reloadTableComponent = async (signal) => {
    const operators = await this.props.operatorContext.fetchOperators(signal);
    this.setState({ operators });
  };

  componentWillUnmount() {
    const { appContext } = this.props;
    appContext.unregisterReloadFunction();
    appContext.setNotification(null);
  }

  initializeTable = async () => {
    this.setState({ loadingSettings: true });
    await this.reloadTableComponent();
    this.setState({ loadingSettings: false });
  };

  onFirstNameChange = (firstName) => {
    this.setState({ form: { ...this.state.form, firstName } });
  };

  onLastNameChange = (lastName) => {
    this.setState({ form: { ...this.state.form, lastName } });
  };

  onOperatorIdChange = (operatorId) => {
    this.setState({ form: { ...this.state.form, operatorId } });
  };

  onEmailChange = (email) => {
    this.setState({ form: { ...this.state.form, email } });
  };

  onEditOperator = (props) => {
    const form = props;
	this.setState({ form }, function() {
      this.getSiteList(true, form.sites);
    });
    this.props.appContext.notificationModal.hasNotification = false;
    this.props.appContext.notificationModal.notificationText = '';
    this.props.appContext.notificationModal.severity = '';
    this.setState({ openEdit: true });
  };

  /**
   * Fetch the operator settings from api and set the default in platform drop down, then populate the properties table
   */
  onOperatorSettings = async (operator) => {
    const form = operator;
    this.setState({ form });
    const platformList = await this.props.operatorContext.fetchOperatorSettings(
      operator.operatorId
    );

    if (platformList !== null && platformList.length > 0) {
      this.setState({ platformOptions: platformList });
      this.setState({ selectedPlatformValue: platformList[0].value });
      this.populatePropertyTable(platformList[0].value);
    }
    this.setState({ openOpSettings: true });
  };

  /**
   * Populate property table on the platform drop down change
   */
  changePlatform = (platform) => {
    this.setState({ selectedPlatformValue: platform });
    this.populatePropertyTable(platform);
  };

  /**
   * Populates property table
   */
  populatePropertyTable = (platform) => {
    const allProperties = [];
    for (const key in platform) {
      if (platform.hasOwnProperty(key)) {
        allProperties.push({ key, value: platform[key] });
      }
    }
    this.setState({ allProperties });
  };

  onManageOperatorTemplate = async (props) => {
    await this.props.operatorContext.setSelectedOperator(props);
    await this.props.history.push({
      pathname: Routes.ManageOperatorTemplates,
      state: this.props.operatorContext.selectedRows[0],
    });
  };

  userActionIcons = (props) => {
    return (
      <div>
        <a onClick={() => this.onManageOperatorTemplate(props)}>
          <Tooltip
            element={<Icon name="voice-message" size="large" />}
            content="Manage operator templates"
            position="top right"
          />
        </a>
        <a onClick={() => this.onOperatorSettings(props)}>
          <Tooltip
            element={<Icon name="settings" size="large" />}
            content="Operator Settings"
            position="top right"
          />
        </a>
        <a onClick={() => this.onEditOperator(props)}>
          <Icon name="edit" size="large" />
        </a>
        <a onClick={() => this.handleSingleDeleteModal(props)}>
          <Icon name="delete" size="large" />
        </a>
      </div>
    );
  };

  toggleMultipleDelete = (e) => {
    if (e.length > 1) {
      this.setState({ disableMultipleDelete: false });
    } else {
      this.setState({ disableMultipleDelete: true });
    }
  };

  disableMultipleDelete = () => {
    this.props.operatorContext.toggleConfirmDeleteOperatorsModal();
    this.props.operatorContext.clearSelectedOperators();
    this.setState({ disableMultipleDelete: true });
  };

  handleMultipleDeleteButton = async () => {
    const { appContext, operatorContext } = this.props;
    await operatorContext.deleteOperators();
    appContext.reload();
    this.setState({ disableMultipleDelete: true });
  };

  handleSingleDeleteModal = async (props) => {
    await this.props.operatorContext.setSelectedOperator(props);
    await this.props.operatorContext.toggleConfirmSingleDeleteOperatorModal();
  };

  clearSelectionAfterCancelEdit = () => {
    const form = {
      operatorId: null,
      firstName: null,
      lastName: null,
      email: null,
    };
    this.setState({ openEdit: false });
    this.setState({ open: false });
    this.setState({ openOpSettings: false });
    this.setState({ form });
    this.props.operatorContext.clearSelectedOperators();
    this.props.appContext.notificationModal.hasNotification = false;
    this.props.appContext.notificationModal.notificationText = '';
    this.props.appContext.notificationModal.severity = '';
  };

  clearOperatorSettingsModal = () => {
    const { appContext } = this.props;
    this.setState({
      platformOptions: [],
      selectedPlatformValue: 0,
      openOpSettings: false,
      allProperties: [],
    });
    appContext.setNotificationModal(null, null);
  };

  openAddOperatorModal = () => {
    const form = {
      operatorId: null,
      firstName: null,
      lastName: null,
      email: null,
    };
    this.setState({ form });
    this.getSiteList(false, form.sites);
    this.props.appContext.notificationModal.hasNotification = false;
    this.props.appContext.notificationModal.notificationText = '';
    this.props.appContext.notificationModal.severity = '';
    this.setState({ open: true });
  };

  // function gets all the available sites in the customer
  getSiteList = async (isEditOperator, associatedSites) => {
    const { selectedCustomer } = this.props.custSiteContext;
    let allSites = this.props.custSiteContext.siteList;

    // remove default site from the list
    allSites = allSites.filter((_site) => {
      return _site.value != '-1';
    });

    if (isEditOperator) {
      associatedSites.map(function (site) {
        allSites = allSites.filter((_site) => {
          return _site.value != site.identifier;
        });
      });
    } else {
      const sites = [];
      sites.push({ identifier: -1, siteName: 'Default' });
      // add site in associated list
      this.setState({ form: { ...this.state.form, sites } });
    }
    this.setState({ allSites });
  };

  setAllSites = (allSites) => {
    this.setState({ allSites });
  };

  setSites = (sites) => {
    this.setState({ form: { ...this.state.form, sites } });
  };

  addOperatorSubmit = async () => {
    const { appContext, operatorContext } = this.props;
    const { form } = this.state;
    this.setState({ loadingSettings: true });
    const response = await operatorContext.createOperator(form);
    await appContext.reload();
    this.setState({ loadingSettings: false });
    if (!(response instanceof Error)) {
      this.setState({ open: false });
    }
  };

  editOperatorSubmit = async () => {
    const { appContext, operatorContext } = this.props;
    const { form } = this.state;
    this.setState({ loadingSettings: true });
    const response = await operatorContext.editOperator(form);
    appContext.reload();
    this.setState({ loadingSettings: false });
    if (!(response instanceof Error)) {
      this.setState({ openEdit: false });
    }
  };

  render() {
    return (
      <div style={{ position: 'relative', height: '100%' }}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={12}>
              <h2 />
              {this.renderModal()}
              {this.renderEditModal()}
              {this.renderDeleteModal()}
              {this.renderSingleDeleteModal()}
              {this.renderOperatorSettingsModal()}
              <Loader
                loading={this.state.loadingSettings}
                overlayOpacity={0.2}
                overlayColor="#B2AFAF"
              >
                <div className="placeholder" />
              </Loader>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={12}>
              <DataTable
                key={this.props.custSiteContext.selectedCustomer}
                data={
                  this.state.operators === null
                    ? []
                    : this.state.operators === undefined
                    ? []
                    : this.state.operators
                }
                resizableColumns
                columnResizeMode="fit"
                reorderableColumns={false}
                selection={this.props.operatorContext.selectedRows}
                onSelectionChange={(e) => {
                  this.props.operatorContext.setSelectedRows(e);
                  this.toggleMultipleDelete(e);
                }}
                metaKeySelection={false}
                scrollable
                search
              >
                <DataTable.HeaderBar>
                  <DataTable.HeaderBar.Item
                    content="Add"
                    icon={<Icon name="slidercontrols-plus" size="small" root="common" />}
                    onClick={() => this.openAddOperatorModal()}
                  />
                  <DataTable.HeaderBar.Item
                    content="Delete"
                    icon={<Icon name="user-remove" size="small" root="common" />}
                    disabled={this.state.disableMultipleDelete}
                    onClick={() => this.props.operatorContext.toggleConfirmDeleteOperatorsModal()}
                  />
                  <DataTable.HeaderBar.Item content="" />
                </DataTable.HeaderBar>
                <DataTable.Column selectionMode="multiple" initialWidth={100} />
                <DataTable.Column
                  field="operatorId"
                  header="Operator Id"
                  sortable
                  initialWidth="20%"
                />
                <DataTable.Column
                  field="firstName"
                  header="First Name"
                  sortable
                  initialWidth="20%"
                />
                <DataTable.Column field="lastName" header="Last Name" sortable initialWidth="20%" />
                <DataTable.Column field="email" header="Email" initialWidth="20%" />
                <DataTable.Column
                  field="lastName"
                  header="Actions"
                  sortable={false}
                  initialWidth="20%"
                  renderer={(props) => this.userActionIcons(props.rowData)}
                />
                <DataTable.Pagination
                  itemsPerPage={10}
                  totalItems={
                    this.state.operators === null
                      ? 1
                      : this.state.operators === undefined
                      ? 1
                      : this.state.operators.length
                  }
                  showDisplayDetails
                />
              </DataTable>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }

  renderModal() {
    return (
      <Modal
        onClose={() => this.setState({ open: false })}
        open={this.state.open}
        dimmer={this.state.hasDimmer}
        closeOnDimmerClick={false}
        closeOnDocumentClick={false}
      >
        <Modal.Content>
          {this.props.appContext.notificationModal.hasNotification ? (
            <NotificationHeaderModal context={this.props.appContext} />
          ) : (
            <></>
          )}
          <Grid>
            <Grid.Row>
              <Grid.Column width={12}>
                <h1>Create Operator</h1>
                <Loader
                  loading={this.state.loadingSettings}
                  overlayOpacity={0.2}
                  overlayColor="#B2AFAF"
                >
                  <div className="placeholder" />
                </Loader>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={6}>
                <Input
                  fluid
                  error={null}
                  label="Operator Id (Must match device operator id)"
                  maxLength="30"
                  placeholder="Operator Id"
                  indicator="required"
                  onChange={(data) => this.onOperatorIdChange(data)}
                />
              </Grid.Column>
              <Grid.Column width={6}>
                <Input
                  fluid
                  error={null}
                  label="Email"
                  placeholder="Email"
                  onChange={(data) => this.onEmailChange(data)}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={6}>
                <Input
                  fluid
                  error={null}
                  label="First Name"
                  placeholder="First Name"
                  maxLength="30"
                  indicator="required"
                  onChange={(data) => this.onFirstNameChange(data)}
                />
              </Grid.Column>
              <Grid.Column width={6}>
                <Input
                  fluid
                  error={null}
                  label="Last Name"
                  placeholder="Last Name"
                  maxLength="30"
                  indicator="required"
                  onChange={(data) => this.onLastNameChange(data)}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={4}>
                <InputLabel label="Associated Sites:" />
              </Grid.Column>

              <Grid.Column width={4}>
                <InputLabel label="Available Sites:" />
              </Grid.Column>
            </Grid.Row>
            <SiteTable
              sites={
                this.state.form.sites === null
                  ? []
                  : this.state.form.sites === undefined
                  ? []
                  : this.state.form.sites
              }
              allSites={
                this.state.allSites === null
                  ? []
                  : this.state.allSites === undefined
                  ? []
                  : this.state.allSites
              }
              setAllSites={this.setAllSites}
              setSites={this.setSites}
            />
          </Grid>
        </Modal.Content>
        <Modal.Footer>
          <Button
            type="secondary"
            size="small"
            content="Cancel"
            onClick={() => {
              this.clearSelectionAfterCancelEdit();
            }}
          />
          <Button
            type="primary"
            size="small"
            content="Submit"
            onClick={() => {
              this.addOperatorSubmit();
            }}
          />
        </Modal.Footer>
      </Modal>
    );
  }

  renderEditModal() {
    return (
      <Modal
        onClose={() => this.setState({ openEdit: false })}
        open={this.state.openEdit}
        dimmer={this.state.hasDimmer}
        closeOnDimmerClick={false}
        closeOnDocumentClick={false}
      >
        <Modal.Content>
          {this.props.appContext.notificationModal.hasNotification ? (
            <NotificationHeaderModal context={this.props.appContext} />
          ) : (
            <></>
          )}
          <Grid>
            <Grid.Row>
              <Grid.Column width={12}>
                <h1>Edit Operator</h1>
                <Loader
                  loading={this.state.loadingSettings}
                  overlayOpacity={0.2}
                  overlayColor="#B2AFAF"
                >
                  <div className="placeholder" />
                </Loader>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={6}>
                <Input
                  fluid
                  error={null}
                  label="Operator Id (Must match device operator id)"
                  indicator="required"
                  value={this.state.form.operatorId}
                  disabled="true"
                  onChange={(data) => this.onOperatorIdChange(data)}
                />
              </Grid.Column>
              <Grid.Column width={6}>
                <Input
                  fluid
                  error={null}
                  label="Email"
                  value={this.state.form.email}
                  onChange={(data) => this.onEmailChange(data)}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={6}>
                <Input
                  fluid
                  error={null}
                  label="First Name"
                  maxLength="30"
                  indicator="required"
                  value={this.state.form.firstName}
                  onChange={(data) => this.onFirstNameChange(data)}
                />
              </Grid.Column>
              <Grid.Column width={6}>
                <Input
                  fluid
                  error={null}
                  label="Last Name"
                  maxLength="30"
                  indicator="required"
                  value={this.state.form.lastName}
                  onChange={(data) => this.onLastNameChange(data)}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={4}>
                <InputLabel label="Associated Sites:" />
              </Grid.Column>

              <Grid.Column width={4}>
                <InputLabel label="Available Sites:" />
              </Grid.Column>
            </Grid.Row>
            <SiteTable
              sites={
                this.state.form.sites === null
                  ? []
                  : this.state.form.sites === undefined
                  ? []
                  : this.state.form.sites
              }
              allSites={
                this.state.allSites === null
                  ? []
                  : this.state.allSites === undefined
                  ? []
                  : this.state.allSites
              }
              setAllSites={this.setAllSites}
              setSites={this.setSites}
            />
          </Grid>
        </Modal.Content>
        <Modal.Footer>
          <Button
            type="secondary"
            size="small"
            content="Cancel"
            onClick={() => {
              this.clearSelectionAfterCancelEdit();
            }}
          />
          <Button
            type="primary"
            content="Submit"
            size="small"
            onClick={() => {
              this.editOperatorSubmit();
            }}
          />
        </Modal.Footer>
      </Modal>
    );
  }

  renderOperatorSettingsModal() {
    const { platformOptions } = this.state;
    return (
      <Modal
        onClose={() => this.setState({ openOpSettings: false })}
        open={this.state.openOpSettings}
        dimmer={this.state.hasDimmer}
        closeOnDimmerClick={false}
        closeOnDocumentClick={false}
      >
        <Modal.Content>
          {this.props.appContext.notificationModal.hasNotification ? (
            <NotificationHeaderModal context={this.props.appContext} />
          ) : (
            <></>
          )}
          <Grid>
            <Grid.Row>
              <Grid.Column width={12}>
                <h1>Operator Settings</h1>
                <Loader
                  loading={this.state.loadingSettings}
                  overlayOpacity={0.2}
                  overlayColor="#B2AFAF"
                >
                  <div className="placeholder" />
                </Loader>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={12}>
                <Select
                  value={this.state.selectedPlatformValue}
                  label="Platform"
                  options={platformOptions}
                  onChange={(value) => this.changePlatform(value)}
                  disabled={!(platformOptions.length > 1)}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={12}>
                <InputLabel label="Properties:" />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={12}>
                <DataTable
                  data={this.state.allProperties}
                  resizableColumns
                  columnResizeMode="fit"
                  reorderableColumns={false}
                  scrollable
                  search={false}
                  metaKeySelection={false}
                >
                  <DataTable.Column field="key" header="Property" sortable initialWidth="25%" />
                  <DataTable.Column
                    field="value"
                    header="Value"
                    sortable={false}
                    initialWidth="25%"
                  />
                </DataTable>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Footer>
          <Button
            type="secondary"
            size="small"
            content="Cancel"
            onClick={() => {
              this.clearOperatorSettingsModal();
            }}
          />
        </Modal.Footer>
      </Modal>
    );
  }

  renderDeleteModal() {
    return (
      <AppModal
        isOpen={this.props.operatorContext.isConfirmDeleteModalOpen}
        content="Would you like to delete the selected operators?"
        handleSubmit={() => this.handleMultipleDeleteButton()}
        handleToggle={() => this.disableMultipleDelete()}
      />
    );
  }

  renderSingleDeleteModal() {
    return (
      <AppModal
        isOpen={this.props.operatorContext.isConfirmSingleDeleteModalOpen}
        content="Would you like to delete the selected operator?"
        handleSubmit={async () => {
          await this.props.operatorContext.deleteOperator();
          this.props.appContext.reload();
        }}
        handleToggle={() => this.props.operatorContext.toggleConfirmSingleDeleteOperatorModal()}
      />
    );
  }
}

export default withRouter(
  withApplicationContext(withCustomerSiteContext(withOperatorContext(ViewOperators)))
);
